import React from 'react';
import { useTranslation } from 'react-i18next';
import SafeImage from '../utils/SafeImage';

function formatPrice(price, priceFormat, t) {
    if (!price || price === 0) return priceFormat === 'free' ? t('placeCard.free') : null;
    if (priceFormat === 'pernight') return t('placeCard.perNight', { price });
    return `€${price}`;
}

export default function PlaceCard({
    title, address, image, rating, price,
    specialty, hours, notes, links = [],
    priceFormat = 'full',
}) {
    const { t } = useTranslation();
    const priceDisplay = formatPrice(price, priceFormat, t);

    return (
        <div className="card overflow-hidden hover:shadow-md transition-shadow duration-200">
            {image && (
                <div className="h-48 overflow-hidden">
                    <SafeImage src={image} alt={title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
            )}

            <div className="p-4 flex flex-col gap-2">
                {title    && <h4 className="font-bold text-gray-900 dark:text-gray-100">{title}</h4>}
                {address  && <p className="text-sm text-gray-600 dark:text-gray-400">{address}</p>}
                {specialty && <p className="text-sm font-semibold text-orange-600 dark:text-orange-400">{specialty}</p>}
                {hours    && <p className="text-sm text-blue-600 dark:text-blue-400">🕐 {hours}</p>}

                {(rating || priceDisplay) && (
                    <div className="flex items-center justify-between">
                        {rating  && <span className="badge bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300">⭐ {rating}</span>}
                        {priceDisplay && <span className="font-bold text-primary-700 dark:text-primary-400">{priceDisplay}</span>}
                    </div>
                )}

                {notes && <p className="text-sm italic text-gray-600 dark:text-gray-400">{notes}</p>}

                {links.length > 0 && (
                    <div className="flex flex-col gap-2 mt-1">
                        {links.map((link, i) => (
                            <a
                                key={i}
                                href={link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn-outline text-sm text-center"
                            >
                                {link.label || t('common.link')}
                            </a>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
